import React from 'react';
import ReactDatePicker, { registerLocale } from 'react-datepicker';
import enGB from 'date-fns/locale/en-gb';
import 'react-datepicker/dist/react-datepicker.css';

registerLocale('en-gb', enGB);

class DatePicker extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <ReactDatePicker
                className="form-control"
                dateFormat="dd/MM/yyyy"
                locale={enGB}
                placeholderText={this.props.placeholder}
                {...this.props}
                onChange={value => {
                    // Convert from Local Midnight (WTF) to UTC Midnight
                    // https://stackoverflow.com/questions/53052012/set-timezone-react-datepicker
                    if (value) {
                        value = new Date(value.getTime() - value.getTimezoneOffset() * 60000);
                    }
                    this.props.onChange(value);
                }}
            />
        );
    }

}

export default DatePicker;